export enum MarketingConsentsActionTypes {
  SET_CLOSED_DIALOG = "@@marketingConsents/SET_CLOSED_DIALOG"
}

export type MarketingConsentsAction = { type: MarketingConsentsActionTypes.SET_CLOSED_DIALOG; data: { customerId: string; isClosedDialog: boolean } };

export const setClosedDialog = (customerId: string, isClosedDialog: boolean): MarketingConsentsAction => ({
  type: MarketingConsentsActionTypes.SET_CLOSED_DIALOG,
  data: { customerId, isClosedDialog }
});
